export default __webpack_public_path__ + "static/media/close.a530ed73.svg";